import api from "../api";

import {
  FETCH_ENTITY_ORDERS_BEGIN,
  FETCH_ENTITY_ORDERS_SUCCESS,
  FETCH_ENTITY_ORDERS_FAILURE
} from "../types";

export const fetchEntityOrdersBegin = () => ({
  type: FETCH_ENTITY_ORDERS_BEGIN
});
export const fetchEntityOrdersSuccess = data => {
  return {
    type: FETCH_ENTITY_ORDERS_SUCCESS,
    data
  };
};

export const fetchEntityOrdersFailure = error => ({
  type: FETCH_ENTITY_ORDERS_FAILURE,
  error
});

export const getEntityOrdersList = input => dispatch => {
  dispatch(fetchEntityOrdersBegin());
  return api.entities
    .entityResults(input)
    .then(resp => dispatch(fetchEntityOrdersSuccess(resp)))
    .catch(error => dispatch(fetchEntityOrdersFailure(error)));
};
